import React, { useEffect, useState } from 'react'
import { Alert, Select } from 'antd'
import { WarningOutlined } from '@ant-design/icons'
import { useWizardMaster } from '../../../../../Contexts/WizardMasterContext'
import api from '@utils/api'
import { useOrders } from '@api/useOrders'
const { Option } = Select
export const NonOptimalChosen = () => {
  const { payload, setPayload } = useWizardMaster()
  const handleChange = (value) => {
    const payloadCopy = { ...payload }
    payloadCopy.reason_name = reasonCodes.supply_options.find((r) => r.id === value).reason
    payloadCopy.reason_id = value
    setPayload(payloadCopy)
  }
  const { useOrderReasonCodeQuery } = useOrders()
  const { data: reasonCodes } = useOrderReasonCodeQuery()

  return (
    <div>
      <Alert
        message={
          <div>
            <span className='alert-align'>
              <WarningOutlined className='alert-icon-large' />
            </span>

            <span className='alert-align' style={{ paddingLeft: '1em' }}>
              You have selected a supply option other than what Gravitate recommended,
              <b>please select a reason code to save the order.</b>
            </span>
            <Select
              placeholder='Select a Reason'
              onChange={handleChange}
              style={{ width: 270, float: 'right' }}
              options={reasonCodes?.supply_options?.map((reason) => ({ label: reason.reason, value: reason.id }))}
            />
          </div>
        }
        type='error'
        className='edited-order'
      />
    </div>
  )
}
